import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@matillion/component-library'

import { Header, HeaderTitle, HeaderWithCTA } from 'components/Header'

interface ListingHeaderProps {
  onAdd: VoidFunction
  permission?: boolean
}

const ListingHeader: FunctionComponent<ListingHeaderProps> = ({
  onAdd,
  permission = false
}) => {
  const { t } = useTranslation()

  return (
    <Header fullWidth centerAlign={false}>
      <HeaderWithCTA>
        <HeaderTitle
          data-testid="cloud-provider-credential-title"
          centerAlign={false}
          headerElement="h2"
          format="tm"
          withBottomSpace={false}
        >
          {t('secrets.cloudProviderCredentialsListing.title')}
        </HeaderTitle>

        {permission && (
          <Button
            text={t('secrets.cloudProviderCredentialsListing.buttonText')}
            onClick={onAdd}
            data-testid="add-cloud-provider-credential-button"
            alt="positive"
          />
        )}
      </HeaderWithCTA>
    </Header>
  )
}

export default ListingHeader
